// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'F:/workplace/aiProvide/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import FileProtectOutlined from 'F:/workplace/aiProvide/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FileProtectOutlined';
import BellOutlined from 'F:/workplace/aiProvide/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/BellOutlined';
export default { SmileOutlined, FileProtectOutlined, BellOutlined };
